// client/src/utils/invoice.js
import { API_BASE_URL } from './media';

// Fetches an order's PDF invoice and saves it to the visitor's computer or phone.
// `access` is a guest order's private link code.
export const downloadInvoice = async ({ orderId, invoiceNumber, token, access }) => {
  const query = access ? `?access=${encodeURIComponent(access)}` : '';
  const response = await fetch(`${API_BASE_URL}/api/orders/${orderId}/invoice.pdf${query}`, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  if (!response.ok) throw new Error('Could not download the invoice.');
  const url = window.URL.createObjectURL(await response.blob());
  const link = document.createElement('a');
  link.href = url;
  link.download = `Invoice-${invoiceNumber || orderId}.pdf`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  // Some phones are still reading the file just after the click.
  setTimeout(() => window.URL.revokeObjectURL(url), 30000);
};
